/* eslint-disable */
export enum FinnairLocationType {
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY'
}

